import React from 'react';
import { Dropdown, TextInput, DatePicker, Checkbox, DateTimePicker} from '../InputFields';
import { BaseFormComponentProps } from '../../types';

export type DynamicFieldProps = BaseFormComponentProps & {
    id: any,
    value: any,
    type: 'string' | 'boolean' | 'date' | 'dropdown',
    isReadOnly?: boolean
  } & any;
  
  export const DynamicField = (props: DynamicFieldProps) => {
    const { name, type, isReadOnly, value, label, id, gridSizes, ...rest } = props;
    let correctValue = value;
    switch (type) {
      case 'string':
        return (
          <TextInput
            id={`${name}-${id}`}
            name={name}
            label={label}
            disabled={isReadOnly}
            defaultValue={value}
            variant='outlined'
            {...rest}
          />
        );
      case 'date':
        return (
          <DatePicker
            id={`${name}-${id}`}
            name={name}
            label={label}
            disabled={isReadOnly}
            defaultValue={value}
            {...rest}
          />
        );
      case 'datetime':
        return (
          <DateTimePicker
            id={`${name}-${id}`}
            name={name}
            label={label}
            disabled={isReadOnly}
            defaultValue={value}
            {...rest}
          />
        )
      case 'boolean':
        if (typeof value === 'string') correctValue = value === '1' || value === 'true';
        return (
          <Checkbox
            id={`${name}-${id}`}
            name={name}
            label={label}
            disabled={isReadOnly}
            defaultValue={correctValue}
            {...rest}
          />
        );
      case 'dropdown':
        return (
          <Dropdown
            id={`${name}-${id}`}
            name={name}
            label={label}
            disabled={isReadOnly}
            defaultValue={value}
            {...rest}
          />
        );
      default:
        return null;
    }
  };